import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDifferenceIgnored: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconDifferenceIgnored"><Path fillRule="evenodd" clipRule="evenodd" d="M18.5 3C19.8807 3 21 4.11929 21 5.5V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V5.5C3 4.11929 4.11929 3 5.5 3H18.5ZM15.8535 8.14648C15.6583 7.95122 15.3417 7.95122 15.1465 8.14648L8.14648 15.1465C7.95122 15.3417 7.95122 15.6583 8.14648 15.8535C8.34175 16.0488 8.65825 16.0488 8.85352 15.8535L15.8535 8.85352C16.0488 8.65825 16.0488 8.34175 15.8535 8.14648Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDifferenceIgnored;
